import styled from 'styled-components';
import { useEffect, useState } from 'react';
import FormListWithProps from './FormList';
import FormEditorWithProps from './FormEditor';
import { IAuth } from 'customTypes';

const Root = styled.div`
  flex-shrink: 0;
`;

interface IFormListWithEditor {
  data: any[];
  originData?: any[];
  isLoading?: boolean;
  isError?: boolean;
  auth: IAuth;
  refetch?: () => void;
  menuName?: string;
  onSave?: (formData: any) => void;
  onDelete?: (item: any) => void;
  onUseYnChange?: (item: any, useYn: boolean) => void;
  onNewItemClick?: () => void;
  onReset?: () => void;
}

const FormListWithEditor = ({
  data: initialData = [],
  originData = [],
  isLoading = false,
  isError = false,
  auth,
  refetch,
  menuName,
  onSave,
  onDelete,
  onUseYnChange,
  onNewItemClick,
  onReset,
}: IFormListWithEditor) => {
  const [data, setData] = useState<any[]>(initialData);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [warning, setWarning] = useState(false);

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  if (isLoading) {
    return (
      <div className='centered-content'>
        <div>로딩 중...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className='centered-content'>
        <div>오류가 발생했습니다.</div>
      </div>
    );
  }

  return (
    <div className='content-container setting-medical'>
      <FormListWithProps
        auth={auth}
        originData={originData}
        data={data}
        setData={setData}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        refetch={refetch || (() => {})}
        warning={warning}
        onUseYnChange={onUseYnChange}
        onNewItemClick={onNewItemClick}
        buttonText={`새 ${menuName} 작성`}
      />
      <Root>
        <FormEditorWithProps
          auth={auth}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          data={data}
          refetch={refetch || (() => {})}
          setWarning={setWarning}
          onSave={onSave}
          onDelete={onDelete}
          onReset={onReset}
          onUseYnChange={onUseYnChange}
        />
      </Root>
    </div>
  );
};

export default FormListWithEditor;
